import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FiCalendar,
  FiCheck,
  FiKey,
  FiMail,
  FiMapPin,
  FiPhone,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import "./AadharFulfill.css";
import STATE_CITY from "../../utils/stateCityMapping";
import { consumeStep2ContactRestore } from "../../utils/applyFlowStorage";
import {
  normalizeEmailInput,
  validateEmail,
} from "../../utils/emailValidation";

const normalizeMobileInput = (value) =>
  String(value || "").replace(/\D/g, "").slice(0, 10);

const IconField = ({ icon: Icon, children, className = "" }) => (
  <div className={`loan-icon-field ${className}`.trim()}>
    <span className="loan-icon-field__icon" aria-hidden="true">
      <Icon />
    </span>
    {children}
  </div>
);

const AadharFulfill1 = ({ onBack, onNext }) => {
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileVerified, setMobileVerified] = useState(false);
  const [mobileOtp, setMobileOtp] = useState("");
  const [mobileOtpSent, setMobileOtpSent] = useState(false);
  const [mobileOtpLoading, setMobileOtpLoading] = useState(false);
  const [verifyMobileOtpLoading, setVerifyMobileOtpLoading] = useState(false);
  const [data, setData] = useState(null);
  const [mobileOtpError, setMobileOtpError] = useState("");
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    const storedData = localStorage.getItem("aadhaarData");
    if (storedData) {
      setData(JSON.parse(storedData));
    }

    if (consumeStep2ContactRestore()) {
      const loanStored = localStorage.getItem("loanFormData");
      if (loanStored) {
        const loan = JSON.parse(loanStored);

        if (loan.mobile) {
          setMobile(normalizeMobileInput(loan.mobile));
          setMobileVerified(true);
        }

        const savedEmail = loan.email || loan.email_personal || "";
        if (savedEmail) {
          setEmail(normalizeEmailInput(savedEmail));
        }
      }
    }
  }, []);

  const getFirstName = (n) => n?.split(" ")[0] || "";
  const getLastName = (n) => n?.split(" ").slice(1).join(" ") || "";
  const getDob = (d) => d.dateOfBirth || d.dob || "";

  const getAddress = (d) =>
    [
      d.house,
      d.street,
      d.landmark,
      d.locality,
      d.vtcName,
      d.district,
      d.state,
      d.pincode,
      d.country,
      d.address,
    ]
      .filter(Boolean)
      .join(", ");

  const normalize = (str = "") => {
    return String(str)
      .toLowerCase()
      .replace(/[^a-zA-Z\s]/g, " ")   
      .replace(/\s+/g, " ")           
      .trim();                         
  };

  const findStateCityIds = (stateName, cityName) => {
    const nState = normalize(stateName);
    const nCity = normalize(cityName);

    for (const key in STATE_CITY) {
      const state = STATE_CITY[key];
      const sName = normalize(state.state_name);

      if (nState === sName) {
        const stateId = state.state_id;

        for (const cityId in state.cities) {
          const cName = normalize(state.cities[cityId]);

          if (
            nCity === cName ||
            nCity.includes(cName) ||
            cName.includes(nCity)
          ) {
            return { stateId, cityId };
          }
        }

        return { stateId, cityId: "" };
      }
    }

    return { stateId: "", cityId: "" };
  };

  // Send OTP to mobile - Original working code
  const sendMobileOtp = async () => {
  if (!mobile || mobile.length !== 10) {
    setMobileOtpError(
      "Please enter a valid 10-digit mobile number."
    );
    return;
  }

  setMobileOtpLoading(true);

  // CLEAR OLD ERROR
  setMobileOtpError("");

  try {
    const cleanNumber = mobile
      .toString()
      .replace(/\D/g, "")
      .slice(-10);

    const params =
      new URLSearchParams();

    params.append(
      "mobile",
      cleanNumber
    );

    console.log(
      "Request bhej rahe hain:",
      cleanNumber
    );

    const resp = await axios.post(
      "https://dhanwalle.in/Api/TaskApi/sendOtp",
      params,
      {
        headers: {
          "Content-Type":
            "application/x-www-form-urlencoded",
        },
      }
    );

    console.log(
      "FULL API RESPONSE =>",
      resp.data
    );

    // API RESPONSE
    const apiResponse =
      resp.data?.api_response || {};

    const apiReturn =
      apiResponse?.return;

    const apiStatusCode =
      apiResponse?.status_code;

    const apiMessage = Array.isArray(
  apiResponse?.message
)
  ? apiResponse.message[0]
  : apiResponse?.message || "";

    // INVALID NUMBER
    if (
      apiReturn === false ||
      apiStatusCode === 411 ||
      apiMessage
        .toLowerCase()
        .includes("invalid")
    ) {
      setMobileOtpSent(false);

      setMobileOtpError(
        apiMessage ||
          "Invalid Numbers"
      );

      return;
    }

    // SUCCESS
    if (apiReturn === true) {
  setMobileOtpSent(true);

  setMobileOtpError("");

  return;
}

    // FALLBACK ERROR
    setMobileOtpSent(false);

    setMobileOtpError(
      resp.data?.message ||
        "Failed to send OTP."
    );
  } catch (err) {
    console.error(
      "OTP Error Detail:",
      err
    );

    setMobileOtpSent(false);

    setMobileOtpError(
      "Server error. Please try again."
    );
  } finally {
    setMobileOtpLoading(false);
  }
};

  // Verify mobile OTP - Original working code
  const verifyMobileOtp = async () => {
    if (!mobileOtp || mobileOtp.length < 4) {
      setMobileOtpError("Please enter a valid OTP");
      return;
    }

    setVerifyMobileOtpLoading(true);
    setMobileOtpError("");
    try {
        const cleanMobile = mobile.toString().replace(/\D/g, '').slice(-10);
        const cleanOtp = mobileOtp.toString().trim();

        console.log("Verifying OTP - Mobile:", cleanMobile, "OTP:", cleanOtp);

        const params = new URLSearchParams();
        params.append('mobile', cleanMobile);
        params.append('otp', cleanOtp);

        const resp = await axios.post("https://dhanwalle.in/Api/TaskApi/verifyOtp", params, {
            headers: { 
                'Content-Type': 'application/x-www-form-urlencoded' 
            }
        });

        console.log("API Response:", resp.data);

        if (resp.data.status === true) {

          setMobileVerified(true);
      
          // NEW
          localStorage.setItem("mobile_verified", "true");
          localStorage.setItem("mobile_otp", cleanOtp);
          localStorage.setItem("mobileNumber", cleanMobile);
      
      } else {
      
          // NEW
          localStorage.setItem("mobile_verified", "false");
          localStorage.removeItem("mobile_otp");
      
          setMobileOtpError(
              resp.data.message ||
              "Entered OTP is incorrect"
          );
      }
    } catch (err) {

    console.error(
      "Verification Error Detail:",
      err
    );

    // API RESPONSE MESSAGE
    const errorMessage =
      err?.response?.data?.message;

    setMobileOtpError(
      errorMessage ||
      "OTP verification failed."
    );
} finally {
      setVerifyMobileOtpLoading(false);
    }
  };

  const handleContinue = () => {
    if (!mobile || mobile.length !== 10) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (!mobileVerified) {
      alert("Please verify your mobile number first.");
      return;
    }

    const normalizedEmail = normalizeEmailInput(email);
    const emailValidationError = validateEmail(normalizedEmail);
    if (emailValidationError) {
      setEmailError(emailValidationError);
      return;
    }

    // Store updated data for loan form - Original format
    const { stateId, cityId } = findStateCityIds(data.state, data.district);
    const loanFormData = {
      // Original format for external API
      firstName: getFirstName(data.name),
      lastName: getLastName(data.name),
      pincode: data.pincode || "",
      state: data.state || "",
      district: data.district || "",
      gender: data.gender,
      dob: getDob(data),
      email: normalizedEmail,
      mobile: mobile,
      otp: localStorage.getItem("mobile_otp") || mobileOtp || "",
      address: getAddress(data),
      state_id: stateId,
      city_id: cityId,
      // Keep original fields for compatibility
      first_name: getFirstName(data.name),
      middle_name: getLastName(data.name),
      last_name: getLastName(data.name),
      email_personal: normalizedEmail,
    };

    localStorage.setItem("loanFormData", JSON.stringify(loanFormData));
    onNext();
  };

  if (!data) {
    return (
      <div className="apply-form-head">
        <h2>Loading...</h2>
        <p>Fetching your Aadhaar details</p>
      </div>
    );
  }

  return (
    <>
      <div className="apply-form-head">
        <div className="apply-now1-hero">
          <span className="apply-now1-hero__eyebrow">Step 2 Of 3</span>
          <h2>Confirm Details</h2>
          <p>Verify mobile and add email to continue.</p>
        </div>
      </div>

      <div className="apply-form-block apply-form-block--accent">
        <div className="apply-now1-section-head">
          <div className="apply-now1-section-head__copy">
            <p className="apply-form-block__title">Contact - Mobile & Email</p>
          </div>
        </div>
        <div className="apply-form-row">
          <div>
            <div className="apply-field" style={{ marginBottom: 0 }}>
              <label>Mobile <span className="req">*</span></label>
              <div className="apply-flow-mobile-row">
                <div className="apply-flow-mobile-input-wrap">
                  <IconField icon={FiPhone}>
                    <input
                      type="tel"
                      inputMode="numeric"
                      maxLength={10}
                      value={mobile}
                      onChange={(e) => {
                        setMobile(normalizeMobileInput(e.target.value));
                        setMobileVerified(false);
                        setMobileOtpError("");
                        setMobileOtpSent(false);
                        setMobileOtp("");
                        localStorage.setItem("mobile_verified", "false");
                        localStorage.removeItem("mobile_otp");
                      }}
                      placeholder="10-digit mobile"
                      className={`apply-flow-input ${mobileVerified ? "is-verified" : ""}`}
                    />
                  </IconField>
                  {mobileVerified && (
                    <span className="apply-flow-input-check" aria-label="Mobile verified">
                      <FiCheck />
                    </span>
                  )}
                </div>
                <button
                  className="apply-flow-btn apply-flow-btn--primary"
                  onClick={sendMobileOtp}
                  disabled={
                    mobileVerified ||
                    mobileOtpLoading ||
                    mobile.length !== 10
                  }
                  style={{ minWidth: "96px", padding: "0.6rem 0.75rem" }}
                >
                  {mobileOtpLoading ? "..." : "OTP"}
                </button>
              </div>
              {mobileOtpError && !mobileOtpSent && <div className="apply-flow-error">{mobileOtpError}</div>}
              {mobileOtpSent && !mobileVerified && (
                <>
                  <div className="apply-flow-otp-row">
                    <IconField icon={FiKey}>
                      <input
                        type="text"
                        value={mobileOtp}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) {
                            setMobileOtp(e.target.value);
                            setMobileOtpError("");
                          }
                        }}
                        placeholder="6-digit OTP"
                        maxLength={6}
                        className={`apply-flow-input ${mobileOtpError ? "error" : ""}`}
                      />
                    </IconField>
                    <button
                      className="apply-flow-btn apply-flow-btn--primary"
                      onClick={verifyMobileOtp}
                      disabled={verifyMobileOtpLoading || mobileOtp.length !== 6}
                      style={{ minWidth: "80px" }}
                    >
                      {verifyMobileOtpLoading ? "..." : "Verify"}
                    </button>
                  </div>
                  {mobileOtpError && <div className="apply-flow-error">{mobileOtpError}</div>}
                </>
              )}
            </div>
          </div>

          <div>
            <div className="apply-field" style={{ marginBottom: 0 }}>
              <label>Email <span className="req">*</span></label>
              <IconField icon={FiMail}>
                <input
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\s/g, "");
                    setEmail(value);
                    if (emailError) {
                      setEmailError(validateEmail(value));
                    }
                  }}
                  onBlur={() => {
                    const normalized = normalizeEmailInput(email);
                    setEmail(normalized);
                    if (normalized) {
                      setEmailError(validateEmail(normalized));
                    }
                  }}
                  placeholder="yourname@gmail.com"
                  className={emailError ? "apply-flow-input error" : "apply-flow-input"}
                />
              </IconField>
              {emailError && <div className="apply-flow-error">{emailError}</div>}
            </div>
          </div>
        </div>
      </div>

      <div className="apply-form-block">
        <div className="apply-now1-section-head">
          <div className="apply-now1-section-head__copy">
            <p className="apply-form-block__title">From Aadhaar</p>
          </div>
        </div>
        <div className="aadhaar-new-form-grid">
          <div className="aadhaar-new-form-item">
            <label>First Name</label>
            <IconField icon={FiUser}>
              <input value={getFirstName(data.name)} disabled />
            </IconField>
          </div>
          <div className="aadhaar-new-form-item">
            <label>Last Name</label>
            <IconField icon={FiUser}>
              <input value={getLastName(data.name)} disabled />
            </IconField>
          </div>
          <div className="aadhaar-new-form-item">
            <label>DOB</label>
            <IconField icon={FiCalendar}>
              <input value={getDob(data)} disabled />
            </IconField>
          </div>
          <div className="aadhaar-new-form-item">
            <label>Gender</label>
            <IconField icon={FiUsers}>
              <input value={data.gender || ""} disabled />
            </IconField>
          </div>
          <div className="aadhaar-new-form-item aadhaar-new-full-width">
            <label>Address</label>
            <IconField icon={FiMapPin} className="loan-icon-field--textarea">
              <textarea rows="2" value={getAddress(data)} disabled />
            </IconField>
          </div>
        </div>
      </div>

      <div className="apply-flow-actions">
        <button className="apply-flow-btn apply-flow-btn--secondary" onClick={onBack}>Back</button>
        <button className="apply-flow-btn apply-flow-btn--primary" onClick={handleContinue}>Continue</button>
      </div>
    </>
  );
};

export default AadharFulfill1;
